'use client';

import { CreateAccountForm } from '@/types/create-account-form.types';

export type RegistrationData = {
  maskedEmail: string;
  message: string;
  token: string;
  hideSocialName?: boolean;
  lastPinRequest?: string;
  returnUrl?: string;
  formData: CreateAccountForm;
};

const REGISTRATION_KEY = 'registration';

export const setRegistrationStorage = (data: RegistrationData) => {
  localStorage.setItem(REGISTRATION_KEY, JSON.stringify(data));
};

export const getRegistrationStorage = (): RegistrationData | null => {
  try {
    const data = localStorage.getItem(REGISTRATION_KEY);

    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

export const removeRegistrationStorage = () => {
  localStorage.removeItem(REGISTRATION_KEY);
};
